import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Header from 'components/AuthStyling';
import BasePasswordPanel from 'components/Forms/BasePasswordPanel';
import API from 'services/api';

import styles from './index.module.scss';
import { logoutUser } from 'reducers/auth';
import { errorHandler } from '../../utils/errorMessages';
import PopUp from 'components/Operational/PopUp/PopUp';
import { popupText } from 'utils/constants/popupText';

const ChangePassword = ({ logout, history }) => {
  const [error, setError] = useState();

  const changePwd = useCallback(
    async (oldPwd, newPwd) => {
      try {
        await API.changePassword(oldPwd, newPwd);
        logout();
      } catch (err) {
        setError(errorHandler(err));
      }
    },
    [logout],
  );
  const cancel = () => {
    history.push('dashboard');
  };

  const resetError = () => {
    setError(null);
  };

  return (
    <>
      <Header message="change_password_label" className={styles.LegalPara}>
        <BasePasswordPanel
          submit={changePwd}
          cancel={cancel}
          submitBtnText="Update Password"
          oldPassword={true}
          havingCancel={true}
          passwordPlaceholder="New Password"
        />
      </Header>
      {error && (
        <PopUp
          title={popupText.passwordResetError.popupTitle}
          statusMessage={error}
          submit={resetError}
          submitBtnText={popupText.passwordResetError.submitBtnText}
          cancel={resetError}
          cancelBtnText={popupText.passwordResetError.cancelBtnText}
          close={resetError}
        />
      )}
    </>
  );
};
ChangePassword.propTypes = {
  logout: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

const mapDisptachToProps = (dispatch, props) => ({
  logout: () => dispatch(logoutUser(props.history)),
});

export default connect(null, mapDisptachToProps)(ChangePassword);
